"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function filterUndefined(value) {
    return value !== undefined;
}
function takeFirst(first, second) {
    return first;
}
exports.takeFirst = takeFirst;
exports.DoneIteratorResult = {
    done: true,
    value: undefined,
};
exports.EmptyIterator = {
    next: function () {
        return exports.DoneIteratorResult;
    }
};
var hasOwnProperty = Object.prototype.hasOwnProperty;
function assign(target, source) {
    for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
            target[key] = source[key];
        }
    }
    return target;
}
exports.assign = assign;
function toArray(it) {
    var arr = [];
    for (var res = it.next(); !res.done; res = it.next()) {
        arr.push(res.value);
    }
    return arr;
}
exports.toArray = toArray;
function forEach(callback) {
    var iterators = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        iterators[_i - 1] = arguments[_i];
    }
    for (var i = 0, j = iterators.length; i < j; ++i) {
        for (var it_1 = iterators[i], next = it_1.next(); !next.done; next = it_1.next()) {
            callback(next.value);
        }
    }
}
exports.forEach = forEach;
function combineIterators() {
    var iterators = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        iterators[_i] = arguments[_i];
    }
    var iteratorIndex = 0;
    return {
        next: function () {
            if (iteratorIndex >= iterators.length) {
                return exports.DoneIteratorResult;
            }
            var res = iterators[iteratorIndex].next();
            if (res.done) {
                iteratorIndex += 1;
                if (iteratorIndex >= iterators.length) {
                    return exports.DoneIteratorResult;
                }
                res = iterators[iteratorIndex].next();
            }
            if (res.done) {
                return exports.DoneIteratorResult;
            }
            return {
                done: false,
                value: res.value,
            };
        }
    };
}
exports.combineIterators = combineIterators;
function createMappedIterator(it, mapper) {
    return {
        next: function () {
            var res = it.next();
            if (res.done) {
                return exports.DoneIteratorResult;
            }
            return {
                done: false,
                value: mapper(res.value),
            };
        }
    };
}
exports.createMappedIterator = createMappedIterator;
function createFilteredIterator(it, filter) {
    if (filter === void 0) { filter = filterUndefined; }
    return {
        next: function () {
            var res = it.next();
            while (!res.done && !filter(res.value)) {
                res = it.next();
            }
            return res;
        }
    };
}
exports.createFilteredIterator = createFilteredIterator;
function createChainedIterator() {
    var its = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        its[_i] = arguments[_i];
    }
    var i = -1;
    var currentIterator = exports.EmptyIterator;
    return {
        next: function () {
            var currentNext = currentIterator.next();
            while (currentNext.done) {
                var it_2 = its[++i];
                if (it_2 === undefined) {
                    return exports.DoneIteratorResult;
                }
                currentIterator = it_2;
                currentNext = currentIterator.next();
            }
            return {
                done: false,
                value: currentNext.value,
            };
        }
    };
}
exports.createChainedIterator = createChainedIterator;
function createFlatMappedIterator(iterator, mapper) {
    var subIterator = exports.EmptyIterator;
    return {
        next: function () {
            var subNext = subIterator.next();
            while (subNext.done) {
                var next = iterator.next();
                if (next.done) {
                    return exports.DoneIteratorResult;
                }
                subIterator = mapper(next.value);
                subNext = subIterator.next();
            }
            return {
                done: false,
                value: subNext.value,
            };
        }
    };
}
exports.createFlatMappedIterator = createFlatMappedIterator;
function createArrayIterator(array) {
    var i = 0;
    return {
        array: array,
        next: function () {
            while (array[i] === undefined) {
                if (i > array.length) {
                    return exports.DoneIteratorResult;
                }
                i += 1;
            }
            return {
                done: false,
                value: array[i++],
            };
        }
    };
}
exports.createArrayIterator = createArrayIterator;
function createMappedArrayIterator(arr, mapFn) {
    var i = 0;
    return {
        next: function () {
            while (arr[i] === undefined) {
                if (i > arr.length) {
                    return exports.DoneIteratorResult;
                }
                i += 1;
            }
            return {
                done: false,
                value: mapFn(arr[i++]),
            };
        }
    };
}
exports.createMappedArrayIterator = createMappedArrayIterator;
function canContractEdge(adapter, from, to) {
    if (!adapter.hasEdge(from, to)) {
        return false;
    }
    var data = adapter.getEdgeData(from, to);
    adapter.deleteEdge(from, to);
    var result = !adapter.isReachable(from, to);
    adapter.addEdge(from, to, data);
    return result;
}
exports.canContractEdge = canContractEdge;
function contractEdge(adapter, from, to, vertexMerger, edgeMerger) {
    if (vertexMerger === void 0) { vertexMerger = takeFirst; }
    if (!adapter.hasEdge(from, to)) {
        return false;
    }
    var data = adapter.getEdgeData(from, to);
    adapter.deleteEdge(from, to);
    if (adapter.isReachable(from, to)) {
        adapter.addEdge(from, to, data);
        return false;
    }
    var newVertex = vertexMerger(from, to);
    if (newVertex !== from && newVertex !== to && adapter.hasVertex(newVertex)) {
        adapter.addEdge(from, to, data);
        throw new Error("Cannot use existing vertex for edge contraction: " + newVertex);
    }
    performEdgeContraction(adapter, from, to, edgeMerger, newVertex);
    return true;
}
exports.contractEdge = contractEdge;
function performEdgeContraction(adapter, from, to, dataMerger, newVertex) {
    if (dataMerger === void 0) { dataMerger = takeFirst; }
    var succ = [];
    var pred = [];
    if (newVertex !== from) {
        for (var it_3 = adapter.getSuccessorsOf(from), res = it_3.next(); !res.done; res = it_3.next()) {
            var data = adapter.getEdgeData(from, res.value);
            adapter.deleteEdge(from, res.value);
            succ.push([res.value, data]);
        }
        for (var it_4 = adapter.getPredecessorsOf(from), res = it_4.next(); !res.done; res = it_4.next()) {
            var data = adapter.getEdgeData(res.value, from);
            adapter.deleteEdge(res.value, from);
            pred.push([res.value, data]);
        }
    }
    if (newVertex !== to) {
        for (var it_5 = adapter.getSuccessorsOf(to), res = it_5.next(); !res.done; res = it_5.next()) {
            var data = adapter.getEdgeData(to, res.value);
            adapter.deleteEdge(to, res.value);
            succ.push([res.value, data]);
        }
        for (var it_6 = adapter.getPredecessorsOf(to), res = it_6.next(); !res.done; res = it_6.next()) {
            var data = adapter.getEdgeData(res.value, to);
            adapter.deleteEdge(res.value, to);
            pred.push([res.value, data]);
        }
    }
    if (newVertex !== from && newVertex !== to) {
        adapter.addVertex(newVertex);
    }
    for (var _i = 0, succ_1 = succ; _i < succ_1.length; _i++) {
        var node = succ_1[_i];
        var data = adapter.getEdgeData(newVertex, node[0]);
        if (data === undefined) {
            adapter.addEdge(newVertex, node[0], node[1]);
        }
        else {
            var other = node[1];
            adapter.setEdgeData(newVertex, node[0], other !== undefined ? dataMerger(data, other) : data);
        }
    }
    for (var _a = 0, pred_1 = pred; _a < pred_1.length; _a++) {
        var node = pred_1[_a];
        var data = adapter.getEdgeData(node[0], newVertex);
        if (data === undefined) {
            adapter.addEdge(node[0], newVertex, node[1]);
        }
        else {
            var other = node[1];
            adapter.setEdgeData(node[0], newVertex, other !== undefined ? dataMerger(data, other) : data);
        }
    }
    if (newVertex !== to) {
        adapter.deleteVertex(to);
    }
    if (newVertex !== from) {
        adapter.deleteVertex(from);
    }
}
var DummyVertexData = { order: 0, visited: false };
exports.DummyDetector = new (function () {
    function class_1() {
    }
    class_1.prototype.map = function () {
        return exports.DummyDetector;
    };
    class_1.prototype.createVertexData = function (g) {
        return DummyVertexData;
    };
    class_1.prototype.canAddEdge = function (g, from, to) {
        return true;
    };
    class_1.prototype.isReachable = function (g, source, target) {
        return false;
    };
    class_1.prototype.onVertexDeletion = function (g, vertex) { };
    class_1.prototype.supportsOrder = function () {
        return false;
    };
    class_1.prototype.getOrder = function (g, vertex) {
        return -1;
    };
    return class_1;
}())();
